<div class="edit-job-panel-wrapper">
    <ng-container *ngIf="!showAttachFilesPanel">
        <div class="loading-overlay" *ngIf="loading">
            <loading class="loading-align-center"></loading>
        </div>
        <div class="edit-job-panel-content-wrapper scroll-wrapper">
            <custom-scroll>
                <div class="edit-job-panel-content">
                    <div class="edit-job-panel-details">
                        <edit-job-header [job]="job"></edit-job-header>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="edit-job-panel-assigned-user">
                        <edit-job-assigned-user
                            [job]="clonedJob"
                            (userChange)="onAssignedUserChange($event)"
                        ></edit-job-assigned-user>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="edit-job-panel-status">
                        <edit-job-status
                            [jobStatus]="clonedJob?.status"
                            (jobStatusChange)="onJobStatusChange($event)"
                        ></edit-job-status>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="edit-job-panel-tags">
                        <edit-job-tags
                            [jobTags]="clonedJob?.tags"
                            (jobTagsChange)="onJobTagsChange($event)"
                        ></edit-job-tags>
                    </div>
                    <mat-divider></mat-divider>
                    <div class="edit-job-panel-linked-files">
                        <edit-linked-project-files
                            [linkedFiles]="editLinkedFiles"
                            (linkedFilesChange)="onLinkedFilesChange($event)"
                        ></edit-linked-project-files>
                    </div>
                </div>
            </custom-scroll>
        </div>
        <div class="edit-job-panel-footer">
            <gsp-button
                [type]="ButtonType.Default"
                text="{{ 'cancel' | translate }}"
                (action)="cancelEditAction()"
            ></gsp-button>
            <gsp-button
                [type]="ButtonType.Primary"
                [disabled]="!isJobUpdated()"
                text="{{ 'TC.Common.Done' | translate }}"
                (action)="updateJob()"
            ></gsp-button>
        </div>
    </ng-container>
    <ng-container *ngIf="showAttachFilesPanel">
        <attach-files
            class="attach-files-panel-wrapper"
            [files]="editLinkedFiles"
            (filesSelected)="onFilesSelected($event)"
        ></attach-files>
    </ng-container>
</div>
